export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2 text-center">
            <i className="ri-information-line text-accent-500 mr-2 w-6 h-6 inline-flex items-center justify-center align-middle"></i>
            关于51吃瓜官网
          </h2>
          <p className="text-sm text-foreground-500 mb-8 text-center">了解51吃瓜网今日吃瓜平台背后的故事</p>

          <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 rounded-xl bg-primary-500 flex items-center justify-center flex-shrink-0">
                <i className="ri-emotion-laugh-line text-2xl text-background-50 w-7 h-7 flex items-center justify-center"></i>
              </div>
              <div>
                <h3 className="text-lg font-bold font-heading text-foreground-900">51吃瓜官网简介</h3>
                <p className="text-xs text-foreground-500">成立于2022年 · 全网最受欢迎的吃瓜社区</p>
              </div>
            </div>
            <div className="space-y-3 text-sm text-foreground-600 leading-relaxed">
              <p>51吃瓜官网（51吃瓜网）是国内领先的娱乐资讯聚合平台，致力于为吃瓜群众提供全网最新、最全、最及时的吃瓜内容。我们覆盖娱乐圈八卦、社会热点、网络热梗、明星爆料等多个领域，通过51吃瓜网今日吃瓜频道每日更新最新的吃瓜动态。</p>
              <p>作为51吃瓜群众的大本营，我们坚持"每天都有新瓜吃"的理念，聚合来自全网的投稿、爆料和深度分析，打造了吃瓜资源合集和每日吃瓜精选等特色板块。无论你是偶尔围观的闲逛党，还是追瓜不停的重度用户，都能在这里找到属于你的那一口"瓜"。</p>
              <p>平台已累计服务超过 500 万吃瓜群众，日均更新吃瓜内容 200+ 条，是全网更新最快的吃瓜资讯站之一。我们严格保护投稿者隐私，所有爆料均经过脱敏处理，确保吃瓜群众能放心围观。</p>
            </div>
            <div className="grid grid-cols-3 gap-4 mt-6 pt-6 border-t border-background-200/60">
              <div className="text-center">
                <p className="text-2xl font-bold text-primary-500 font-heading">500万+</p>
                <p className="text-xs text-foreground-400 mt-1">注册吃瓜群众</p>
              </div>
              <div className="text-center">
                <p className="text-2xl font-bold text-accent-500 font-heading">200+</p>
                <p className="text-xs text-foreground-400 mt-1">日均更新量</p>
              </div>
              <div className="text-center">
                <p className="text-2xl font-bold text-primary-500 font-heading">99.9%</p>
                <p className="text-xs text-foreground-400 mt-1">服务可用率</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}